export const ThemeColor = "#0D5EA6";
export const ThemeColorDark = "#090040";
export const ColorCardBGLight = "#ffffff";
export const ThemeButtonBGPrimary = "#0D5EA6";
export const ThemeButtonBGAIDetector = "#399769";
export const ThemeButtonBGParaphrase = "#967869"
export const ThemeButtonAccountBG = "#7c8fac";
export const ThemeButtonSummaryBG = "#771de2";
export const ThemeButtonPlagiarismBG = "#d5662a";

//https://humanizetexts.com/humanizer_api/humanize_texts_backend.php
export const REQUEST_URL = "https://humanizetexts.com/humanizer_api/humanize_texts_backend.php";
//https://humanizetexts.com/humanizer_api/query_form.php
export const QUERY_FORM_URL = "https://humanizetexts.com/humanizer_api/query_form.php";
//server authentication url
//https://humanizetexts.com/humanizer_api/authentication.php
export const AUTHENTICATION_URL = "https://humanizetexts.com/humanizer_api/authentication.php";
//paypal checkout url
//https://humanizetexts.com/humanizer_api/paypal_checkout.php
export const PAYPAL_CHECKOUT_URL = "https://humanizetexts.com/humanizer_api/paypal_checkout.php";

//flags
//success failed alert timeout
export const ALERT_TIMEOUT = 5000; // 5 seconds
export const STATUS_CHECK_INTERVAL = 3000; // 3 seconds
export const MAX_AI_TEXT_LENGTH_DEFAULT = 700;
export const MIN_AI_TEXT_LENGTH = 40;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 15;
export const VERIFICATION_MAIL_RESEND_TIME = 30; // in seconds

//probability color values
export const ai_probability_color_values = ["#fcff00", "#fcff1f", "#fdff37", "#fdff50", "#fdff68", "#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff"];